import React from "react";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import MenuItem from "@mui/material/MenuItem";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Select from "@mui/material/Select";
import Paper from "@mui/material/Paper";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function EditCommodity() {
  const history = useHistory();
  let { id } = useParams();
  const data_params = { id: id };
  const EmpId = localStorage.getItem("EmpId");
  const classes = useStyles();

  const [CommodityStatus, setCommodityStatus] = useState(1);
  const [CommodityName, setCommodityName] = useState("");
  const [CommodityNO, setCommodityNO] = useState("");
  const [ModId, setModId] = useState("1");
  const [Submitting, setSubmitting] = useState(false);
  const [detail, setDetail] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [container_data, setContainer_data] = useState([]);
  const [conname, setContainerTypeName] = useState("");
  const [ContainerTypeId, setContainerTypeId] = useState("");
  const [Contai, setContai] = useState([]);
  const [Weight, setWeight] = useState("");
  const [cargoWeight, setCargoWeight] = useState("");
  const [error, setError] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const Addrow = () => {
    if (ContainerTypeId !== "" && Weight.length !== 0) {
      const gwe = [
        ...Contai,
        {
          ContainerTypeId: ContainerTypeId,
          weight: Weight,
          ContainerTypeName: conname,
          id: Contai.length + 1,
          Delete: false,
        },
      ];
      setContai(gwe);
      setContainerTypeId("");
      setContainerTypeName("");
      setWeight("");
      setOpen(false);
      setError(false);
    } else {
      setError(true);
    }
    // console.log(g);
  };

  const handleClose = () => {
    setOpen(false);
    setError(false);
  };
  const getContainer = () => {
    try {
      const Cn = api.get("api/container/list").then((response) => {
        setContainer_data(response.data);
      });
    } catch (err) { }
  };

  const getData = async () => {
    try {
      const data = await api
        .post("api/commodity/detail", data_params)
        .then((response) => {
          if (response.data.length !== 0) {
            setDetail(response.data);
            if (
              response?.data?.detail[0]?.ContainerTypeId !== "null" &&
              response?.data?.detail[0]?.ContainerTypeId !== null
            ) {
              setContai(
                response.data.detail.map((x) => ({
                  ...x,
                  Delete: false,
                }))
              );
            }

            //  response.data.map((res) => {
            setCommodityStatus(response.data.Status ? 1 : 0);
            setCommodityName(response.data.CommodityName);
            setCommodityNO(response.data.CommodityNO);
            setModId(response.data.CommodityId);
            setCargoWeight(response.data.CargoWeight)
            // response.data..map((res) => {
            //   setContainerTypeName(res);
            // });
            //  });
          } else {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/Setting/Commodity");
                }
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const addData = async () => {
    if (CommodityNO !== "" && CommodityName !== "") {
      const data = {
        no: CommodityNO,
        name: CommodityName,
        status: CommodityStatus,
        createId: EmpId,
        weight: cargoWeight,
        detail: Contai.map((r) => ({
          containerId: r.ContainerTypeId,
          weight: r.weight,
        })),
      };

      api
        .post("api/commodity/create", data)
        .then((respose) => {
          const MySwal = withReactContent(Swal);

          MySwal.fire({
            icon: "success",
            didOpen: () => {
              MySwal.clickConfirm();
            },
          }).then(() => {
            return MySwal.fire(
              "สำเร็จ!",
              "เพิ่มสินค้าโภคภัณฑ์ !",
              "success"
            ).then((result) => {
              if (result.isConfirmed) {
                history.push("/Setting/Commodity");
              }
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
      // alert(JSON.stringify(data, null, 2));
      setSubmitting(false);
      setError(false);
    } else {
      setError(true);
    }
  };

  const editData = async () => {
    const data = {
      id: id,
      no: CommodityNO,
      name: CommodityName,
      status: CommodityStatus,
      ModId: EmpId,
      weight: cargoWeight
      // detail: Contai.filter((x) => x.Delete === false).map((x) => ({
      //   containerId: x.ContainerTypeId,
      //   weight: parseInt(x.weight),
      // })),
    };

    api
      .post("api/commodity/update", data)
      .then((respose) => {
        const MySwal = withReactContent(Swal);
        MySwal.fire({
          icon: "success",
          didOpen: () => {
            MySwal.clickConfirm();
          },
        }).then(() => {
          return MySwal.fire(
            "สำเร็จ!",
            "แก้ไขสินค้าโภคภัณฑ์ !",
            "success"
          ).then((result) => {
            if (result.isConfirmed) {
              history.push("/Setting/Commodity");
            }
          });
        });
      })
      .catch((err) => {
        console.log(err);
      });
    setSubmitting(false);
  };
  const handleDeleteRow = (row, index) => {

    const _RowList = Contai.map((item, index2) =>
      row.id === item.id
        ? {
          ...item,
          Delete: true,
        }
        : item
    );
    const select = _RowList.filter((x) => x.Delete === false);
    setContai(select);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (id) {
      editData();
    } else {
      addData();
    }
  };

  useEffect(() => {
    getContainer();
    if (id) {
      getData();
    }
  }, []);

  return (
    <div>
      <Card
        variant="outlined"
        style={{
          padding: "20px",
          margin: "25px",
          height: "86vh",
          overflow: "auto",
        }}
      >
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          สินค้าโภคภัณฑ์
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Commodity
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Commodity
            </Typography>
          </Grid>
        </Grid>

        <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
          <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
            สินค้าโภคภัณฑ์
          </h6>
          <Grid container>
            <Grid item xs={6} sm={3} md={12}>
              <TextField
                name="NameCommodity"
                label="Name Commodity"
                variant="outlined"
                // error={error}
                // helperText={error === true ? "กรุณากรอกข้อมูลให้ครบ" : ""}
                placeholder="Enter Name Commodity"
                style={{
                  width: "50%",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
                onChange={(e) => setCommodityName(e.target.value)}
                // onBlur={handleBlur}
                InputLabelProps={{ shrink: true }}
                value={CommodityName}
                classes={{ root: !CommodityName ? classes.customOutline : null }}
                required
              />
            </Grid>
            <Grid item xs={6} sm={3} md={12}>
              <TextField
                label="Weight"
                variant="outlined"
                // error={error}
                // helperText={error === true ? "กรุณากรอกข้อมูลให้ครบ" : ""}
                placeholder="Enter Weight"
                style={{
                  width: "50%",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
                onChange={(e) => setCargoWeight(e.target.value)}
                // onBlur={handleBlur}
                InputLabelProps={{ shrink: true }}
                value={cargoWeight}
                classes={{ root: !cargoWeight ? classes.customOutline : null }}
                required
              />
            </Grid>
            <Grid item xs={6} sm={4} md={10} sx={{ display: "flex" }}>
              <TextField
                label="Commodity NO."
                InputLabelProps={{ shrink: true }}
                placeholder="Enter Commodity NO."
                name="CommodityNO"
                // error={error}
                style={{
                  width: "40%",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
                onChange={(e) => setCommodityNO(e.target.value)}
                // onBlur={handleBlur}
                value={CommodityNO}
                classes={{ root: !CommodityNO ? classes.customOutline : null }}
                required
              />
              {/* {errors.polpod_no && touched.polpod_no && errors.polpod_no} */}

              <FormControl fullWidth>
                <InputLabel id="select_status-label" sx={{
                  left: '10px', top: '10px'
                }}>Status</InputLabel>
                <Select
                  name="select_status"
                  id="select_status"
                  value={CommodityStatus}
                  label="Status"
                  style={{
                    width: "43%",
                    marginLeft: "10px",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  onChange={(e) => setCommodityStatus(e.target.value)}
                >
                  <MenuItem value={1}>Active</MenuItem>
                  <MenuItem value={0}>InActive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Button
            type="button"
            variant="outlined"
            style={{
              color: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
            onClick={history.goBack}
          >
            back
          </Button>
          <Button
            type="submit"
            variant="contained"
            style={{
              background: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
            disabled={Submitting}
          >
            {Submitting && <CircularProgress size={22} />}
            {!Submitting && "SAVE"}
          </Button>
        </form>
        {/* <Button
          type="button"
          variant="contained"
          onClick={handleClickOpen}
          style={{
            background: "#80c340",
            borderColor: "#80c340",
            marginLeft: "20px",
          }}
        >
          Add Row
        </Button>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle>{"ADD ROW"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Grid item xs={6} sm={3} md={12}>
                <TextField

                  value={Weight}
                  variant="outlined"
                  type="number"
                  label="Weight"
                  placeholder="Weight"
                  style={{
                    width: "300px",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  onChange={(e) => setWeight(e.target.value)}
                  // onBlur={handleBlur}
                  classes={{ root: !Weight ? classes.customOutline : null }}
                  required
                />
              </Grid>
              <FormControl fullWidth classes={{ root: !ContainerTypeId ? classes.customOutline : null }}
                required>
                <InputLabel id="select_status-label">container</InputLabel>
                <Select
                  name="conname"
                  value={ContainerTypeId}
                  label="Status "
                  style={{
                    width: "300px",

                    marginBottom: "10px",
                  }}
                  onChange={(e, newValue) => {
                    setContainerTypeId(e.target.value);
                    setContainerTypeName(newValue.props.children);
                  }}

                >
                  {container_data.map((x) => (
                    <MenuItem value={x.ContainerTypeId}>
                      {x.ContainerTypeName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleClose}
              variant="outlined"
              style={{
                color: "#80c340",
                borderColor: "#80c340",
                marginRight: "10px",
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              style={{
                background: "#80c340",
                borderColor: "#80c340",
                marginRight: "10px",
              }}
              onClick={Addrow}
              autoFocus
            >
              add
            </Button>
          </DialogActions>
        </Dialog>
        {Contai.length !== 0 ? (
          <TableContainer
            component={Paper}
            sx={{
              height: "40vh",
              maxHeight: "40vh",
              overflow: "auto",
              margin: "30px 0px",
            }}
          >
            <Table
              sx={{ minWidth: 650, marginTop: "15px" }}
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  <TableCell align="center"># </TableCell>
                  <TableCell align="center">ขนาดตู้คอนเทนเนอร์ </TableCell>
                  <TableCell align="center">น้ำหนัก (Weight)</TableCell>
                  <TableCell align="center"></TableCell>
                </TableRow>
              </TableHead>
              {console.log(Contai)}
              <TableBody>
                {Contai?.filter((x, index) => x.Delete !== true).map(
                  (row, index) => (
                    <TableRow
                      key={row.name}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell align="center">{index + 1}</TableCell>
                      <TableCell align="center">
                        {row.ContainerTypeName}
                      </TableCell>
                      <TableCell align="center">{row.weight}</TableCell>
                      <TableCell align="center">
                        <Button
                          variant="outlined"
                          style={{
                            color: "#FF0000",
                            borderColor: "#FF0000",
                          }}
                          onClick={() => handleDeleteRow(row, index)}
                        >
                          ลบ
                        </Button>
                      </TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          ""
        )} */}
      </Card>
    </div>
  );
}
